///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.supply_issues = abcsetup.rfq.supply_issues || {};
abcsetup.rfq.supply_issues.history = abcsetup.rfq.supply_issues.history || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.supply_issues.history = {
    init: function () {
        abcsetup.setTitle('Supply Issue History');

        abcsetup.rfq.supply_issues.comments.init();
    },
}
